<template>
    <section
        ref="section22"
        :class="[
            Object.keys(validationErrors).length > 0 ? 'has-errors' : '',
            'mx-auto flex h-full flex-col',
        ]"
    >
        <v-add-listing-head :routes="routes" :step="30"></v-add-listing-head>
        <main class="flex h-full flex-col items-center overflow-y-scroll px-4 py-8 md:px-12 gap-11">
            <figure class="mx-auto flex w-full max-w-xl gap-3">
                <div><v-icon icon="add-to-photos" size="8"></v-icon></div>
                <div class="flex flex-col justify-center">
                    <div class="mb-3 text-heading-3-desktop">
                        Kateri kontaktni podatki želite da so vidni na oglasu?
                    </div>
                    <div class="text-body-regular text-black-40">
                        Izberite kako želite, da vas iskalci kontaktirajo. Izberete lahko več možnosti
                    </div>
                </div>
            </figure>
            <figure class="relative flex max-w-3xl flex-col gap-11 w-full">
                <form
                    method="POST"
                    :action="routes.submitForm"
                    id="show_personal_data"
                >
                    <v-csrf-token></v-csrf-token>
                    <figure class="ml-auto mr-auto w-full max-w-xl">
                        <ul class="flex flex-col gap-4">
                            <li
                                class="col-span-4"
                            >
                                <v-checkbox
                                    class="text-small-text-medium text-black-78"
                                    checkbox-position="right"
                                    label="<span class='text-black-78 text-heading-4-medium'>Telefonska številka</span>"
                                    :description="stepData.user_phone_number"
                                    iconSize="6"
                                    icon="phone"
                                    name="show_phone_number"
                                    value="1"
                                    :checked="stepData.show_phone_number ?? false"
                                ></v-checkbox>
                            </li>
                            <li
                                class="col-span-4"
                            >
                                <v-checkbox
                                    class="text-small-text-medium text-black-78"
                                    label="<span class='text-black-78 text-heading-4-medium'>Elektronski naslov</span>"
                                    :description="stepData.user_email"
                                    iconSize="6"
                                    icon="envelope"
                                    checkbox-position="right"
                                    name="show_email"
                                    value="1"
                                    :checked="stepData.show_email ?? false"
                                ></v-checkbox>
                            </li>
                        </ul>
                    </figure>
                </form>
            </figure>
        </main>
        <v-add-listing-foot>
            <a
                @click="submitForm('show_personal_data')"
                class="button button--md h-[48px] w-[240px] px-6"
            >
                <label class="text-small-text-medium">Nadaljujte</label>
                <v-icon icon="arrow-right" size="4"></v-icon>
            </a>
        </v-add-listing-foot>
    </section>
</template>
<script>
import AddListingFootVue from "../AddListingFoot.vue";
import AddListingHeadVue from "../AddListingHead.vue";

export default {
    components: {
        "v-add-listing-foot": AddListingFootVue,
        "v-add-listing-head": AddListingHeadVue,
    },
    props: {
        old: {
            type: Object,
            required: false,
            default: {},
        },
        routes: {
            type: Object,
            required: true,
        },
        validationErrors: {
            type: Object,
            required: true,
            default: {},
        },
        stepData: {
            type: Object,
            required: true,
            default: {},
        },
    },
    data() {
        return {};
    },
    mounted() {},
    computed: {},
    methods: {
        submitForm(formId) {
            document.getElementById(formId).submit();
        },
    },
};
</script>
